import { ContentType, HttpClient, RequestParams } from './http-client';
import { ValidateEmailResponse } from '@/data/types/EmailDomainValidation';

export class ValidateEmail<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}
	validateEmail = (
		storeId: string,
		query: {

			email: string;
		},
		params: RequestParams = {}
	) =>
		this.http.request<ValidateEmailResponse, void>({
			path: `/store/${storeId}/validateemail`,
			method: 'GET',
			query,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
}
